import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from '@/environments/environment';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private router = inject(Router);
  private isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  constructor() {
    if (!this.isBrowser || !environment.gaMeasurementId) return;

    this.loadGtagScript();
    this.trackPageViews();
  }

  private loadGtagScript(): void {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${environment.gaMeasurementId}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    // gtag.js only processes real `arguments` objects; a plain array (e.g. from ...args) is silently ignored
    window.gtag = function () {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    // send_page_view: false because we'll fire page_view manually on route change
    window.gtag('config', environment.gaMeasurementId, { send_page_view: false });
  }

  private trackPageViews(): void {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => this.sendPageView(e.urlAfterRedirects));

    // Initial load: NavigationEnd may have already fired before this subscription
    if (this.router.navigated) {
      this.sendPageView(this.router.url);
    }
  }

  private sendPageView(pagePath: string): void {
    // console.log('[GA] page_view', {
    //   page_path: pagePath,
    //   page_location: window.location.href,
    //   page_title: document.title,
    // });
    window.gtag?.('event', 'page_view', {
      page_path: pagePath,
      page_location: window.location.href,
      page_title: document.title,
    });
  }

  logEvent(name: string, params: Record<string, unknown> = {}): void {
    window.gtag?.('event', name, params);
  }
}

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}
